interface DomainSettings {
  REGIONAL_DOMAIN_US?: string;
  REGIONAL_DOMAIN_CA?: string;
  REGIONAL_DOMAIN_EU?: string;
}

export function getRegionalDomain(countryCode: string, settings: DomainSettings): string | null {
  const code = countryCode.toUpperCase();
  if (code === 'US') return settings.REGIONAL_DOMAIN_US ?? null;
  if (code === 'CA') return settings.REGIONAL_DOMAIN_CA ?? null;
  return settings.REGIONAL_DOMAIN_EU ?? null;
}
